// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IEstimationHistoryTitleSchema {
  /** Изменение оценки (увеличение/уменьшение/без изменений) **/
  change: EChange;
  /** Процент изменения оценки **/
  changeValue?: string;
  /** Заголовок для графика **/
  title: string;
}
export enum EChange {
  /** Оценка снизилась **/
  'Decrease' = 'decrease',
  /** Оценка увеличилась **/
  'Increase' = 'increase',
  /** Оценка не изменилась **/
  'NotChanged' = 'notChanged',
}
